export default __webpack_public_path__ + "static/media/30.f186bc1a.svg";